export const NOTIFICATION_ERRORS = {
  fetch: 'NotificationsFetchError',
  updateReadStatus: 'NotificationsUpdateReadStatusError',
  websocket: 'NotificationsWebSocketError',
} as const;
